import { render, staticRenderFns } from "./CopyrightAmendmentApplications.vue?vue&type=template&id=35588488&scoped=true&"
import script from "./CopyrightAmendmentApplications.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentApplications.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentApplications.vue?vue&type=style&index=0&id=35588488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35588488",
  null
  
)

export default component.exports